module.exports = __webpack_public_path__ + "images/16292-INT2-Cam02-27bf111abdeab46e9f1f6a7f75e90b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/16292-INT2-Cam02.jpg
// module id = 32
// module chunks = 0